/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 19:32:02
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:33:32
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import {
  AccountStationSubmitAsync,
  getAccountStationDetailAsync,
  selectAccountDetail,
  selectAccountId,
} from "./AccountSlice";
const { Option } = Select;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

export const AccountModal = (props: {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const [form] = Form.useForm();

  const [title, setTitle] = useState("新增");

  const dispatch = useDispatch<AppDispatch>();

  const selectId = useSelector(selectAccountId);

  const detail = useSelector(selectAccountDetail);

  useEffect(() => {
    if (selectId) {
      dispatch(getAccountStationDetailAsync(selectId));
      setTitle("修改");
    } else {
      setTitle("新增");
    }
  }, [selectId]);

  useEffect(() => {
    if (JSON.stringify(detail) !== "{}") {
      form.setFieldsValue({
        ...detail,
      });
    }
  }, [detail]);

  return (
    <Modal
      title={title + "用户"}
      visible={props.visible}
      onOk={() => {
        props.onOk();
      }}
      onCancel={() => {
        form.resetFields();
        props.onCancel();
      }}
      footer={null}
    >
      <Form
        {...layout}
        autoComplete="off"
        form={form}
        onFinish={(fs) => {
          if (selectId) {
            dispatch(
              AccountStationSubmitAsync({
                ...fs,
                userId: selectId,
              })
            )
              .then(unwrapResult)
              .then(() => {
                form.resetFields();
                props.onOk();
              });
          } else {
            dispatch(AccountStationSubmitAsync(fs))
              .then(unwrapResult)
              .then(() => {
                form.resetFields();
                props.onOk();
              });
          }
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="用户名"
              name="userName"
              rules={[{ required: true, message: "请输入用户名" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="姓名"
              name="nickName"
              rules={[{ required: true, message: "请输入姓名" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="密码"
              name="pwd"
              rules={[
                { required: true, message: "请输入密码" },
                // {
                //   pattern: /^.{6,}$/,
                //   message: "请正确输入六位数密码",
                // }
              ]}
            >
              {/* <Input.Password auto-complete="new-password" /> */}
              <Input placeholder="请输入密码" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="启用状态"
              name="status"
              initialValue={1}
              rules={[{ required: true, message: "请选择启用状态" }]}
            >
              <Select>
                <Option value={0}>停用</Option>
                <Option value={1}>启用</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel();
              }}
              style={{ float: "right" }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
